import React from 'react';
import Header from './Header';
import Hero from './Hero';
import ProductScreenshots from './ProductScreenshots';
import SpineSection from './SpineSection';
import EnterpriseFunctions from './EnterpriseFunctions';
import CaseStudies from './CaseStudies';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Testimonials from './Testimonials';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <Hero />
        <ProductScreenshots />
        <SpineSection />
        <EnterpriseFunctions />
        <CaseStudies />
        <Features />
        <HowItWorks />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
